module.exports = __webpack_public_path__ + "img/48.3.TP.1376f9db.png";